import { useTranslation } from 'react-i18next';
import OnboardContent from '../onboarding/OnboardContent';

import { AnalyticsGraph } from '../icons';
import { useNavigate } from 'react-router-dom';
import { PRIVACY_POLICY_URLS } from '../../constants/constants';
import { useLanguage } from '../../context/LanguageContext';
import { Button } from '../Ant';
import { useAnalytics } from '../../hooks/useAnalytics';
import { useFeatureContext } from '../../context/FeatureContext';
import { getStartModuleRoute } from '../../utils/startModule';

const Analytics = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { language } = useLanguage();
  const { setAnalyticsPermission } = useAnalytics();
  const { startModule } = useFeatureContext();
  const startModuleRoute = getStartModuleRoute(startModule);

  return (
    <div className="d-flex justify-center flex-col items-center h-full pb-gutter">
      <OnboardContent
        title={t('common:analyticsConsentText')}
        subtitle={t('common:analyticsConsentSubText')}
        icon={<AnalyticsGraph />}
      >
        <Button
          data-testid="privacy-policy-button"
          type="text"
          onClick={() => {
            globalThis.open(
              PRIVACY_POLICY_URLS[language as keyof typeof PRIVACY_POLICY_URLS] ??
                PRIVACY_POLICY_URLS.en,
              '_blank',
            );
          }}
        >
          {t('common:viewPrivacyPolicy')}
        </Button>
      </OnboardContent>
      <div className="d-flex justify-between w-full gap-5">
        <Button
          data-testid="skip-button"
          size="large"
          block
          maxwidth="107px"
          onClick={() => {
            setAnalyticsPermission(false);
            navigate(startModuleRoute);
          }}
        >
          {t('common:onboarding.skip')}
        </Button>
        <Button
          data-testid="enable-button"
          size="large"
          block
          type="primary"
          onClick={() => {
            setAnalyticsPermission(true);
            navigate(startModuleRoute);
          }}
        >
          {t('common:onboarding.enable')}
        </Button>
      </div>
    </div>
  );
};

export default Analytics;
